import React, { useState } from 'react';
import data from '../data/portfolio.json';
import { Link } from 'react-router-dom';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { useGSAP } from "@gsap/react";

// Register required GSAP plugins
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

export function Getdata() {
  // --------------------------------------------------
  // STATE MANAGEMENT
  // --------------------------------------------------
  const [scrollPosition, setScrollPosition] = useState(0);
  const [selectedCategory, setSelectedCategory] = useState(() => {
    return sessionStorage.getItem('portCat') || 'All';
  });

  // Filter and sort portfolio data
  const filteredData = data
    .filter(item => selectedCategory === 'All' ? true : item.design_category === selectedCategory)
    .sort((a, b) => b.design_id - a.design_id);

  const handleCategoryChange = (e) => {
    const newCategory = e.target.value;
    setSelectedCategory(newCategory);
    sessionStorage.setItem('portCat', newCategory);

     //<<<<<<<<<<<<<<<<<<<<<<< =========================================================== LAST HERE
      
    //ThumbScrollFX();
  

  };


// end of 












  // --------------------------------------------------
  // GSAP SCROLL & BATCH ANIMATIONS ON MOUNT
  // --------------------------------------------------

/*
  function resetThubnails (){
        gsap.set(".thumbnail-frame", { opacity:0,rotationY: 20, rotationX: -30, perspective: 400 });
        gsap.set(".thumbnail-heading", { opacity: 0 });
}

  useGSAP(() => {
    // 1. Reveal Filters
    const basePreloadDelay = window.isInitialPreload ? 0.8 : 0.2;

    gsap.timeline({
      delay: basePreloadDelay,
      onComplete: () => { window.isInitialPreload = false; }
    }).to(".portfolio-filter", {
      duration: 1,
      opacity: 1,
      transformOrigin: "center center"
    });

    // 2. Batch Scroll Animations for Thumbnails
    const thumbs = gsap.utils.toArray('.thumbnail');

        gsap.set(".thumbnail-frame", { opacity:0,rotationY: 20, rotationX: -30, perspective: 400 });
        gsap.set(".thumbnail-heading", { opacity: 0 });

    if (thumbs.length > 0) {
      ScrollTrigger.batch(thumbs, {
        start: 'top 90%',
        onEnter: batch => {
          const currentDelay = window.isInitialPreload ? 0.6 : 0;

          batch.forEach((section, index) => {

            const thumb_frame = section.querySelectorAll('.thumbnail-frame');
            const thumb_heading = section.querySelectorAll('.thumbnail-heading');
          
            let tl_folder = gsap.timeline({
              delay: currentDelay + (index * 0.15),
              onComplete: () => { window.isInitialPreload = false; }
            });

            tl_folder
              .to(thumb_frame, {
                duration: 1,
                opacity: 1,
                rotationY: 0,
                rotationX: 0,
                transformOrigin: "center center",
                stagger: 0.2,
                ease: "power2.out"
              })
              .to(thumb_heading, { duration: 0.5, opacity: 1 }, "-=0.3");
          });
        },
        once: true
      });
    }

    // 3. Auto Scroll Restoration
    const savedPosition = sessionStorage.getItem('scrollPos');

    const handleScroll = () => {
      const currentPosition = window.scrollY;
      setScrollPosition(currentPosition);
      sessionStorage.setItem('scrollPos', currentPosition);
    };

    if (savedPosition) {
      gsap.to(window, { 
        scrollTo: savedPosition, 
        duration: 1,
        delay: 0.5,
        onComplete: () => {
          window.addEventListener('scroll', handleScroll, { passive: true });
        }
      });
    } else {
      window.addEventListener('scroll', handleScroll, { passive: true });
    }

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // --------------------------------------------------
  // GSAP TRIGGER ON CATEGORY CHANGE
  // --------------------------------------------------
  useGSAP(() => {
    gsap.to(".thumbnail-frame", {
      opacity: 1,
      rotationY: 0,
      rotationX: 0,
      duration: 0.6,
      stagger: 0.1,
      ease: "power2.out",
      overwrite: "auto"
    });

    gsap.to(".thumbnail-heading", {
      opacity: 1,
      duration: 0.4,
      overwrite: "auto"
    });
  }, [selectedCategory]);

  */

  // --------------------------------------------------
  // RENDER
  // --------------------------------------------------
  return (
    <div className="gallery">
      <div className="portfolio-filter">
        <strong>Filter By Design Category</strong>
        <select value={selectedCategory} onChange={handleCategoryChange}>
          <option value="All">Show all Designs</option>
          <option value="Graphic Design">Graphic Design</option>
          <option value="Web Development">Web Development</option>
        </select>
      </div>

      <div className="thumbnail-wrap">
        {filteredData.map(folder => (
          <Link 
            className="thumbnail" 
            to={`/portfolio/${folder.design_slug + '-id-' + folder.design_id}`} 
            key={folder.design_id} 
            data-port-id={folder.design_id} 
          > 
            <div className="thumbnail-frame">
              <div className="thumbnail-image">
                <img src={folder.design_thumbnail} alt={folder.design_type + " id " + folder.design_id} loading="lazy" />
              </div>
              <div className="border-fx-top"></div>
              <div className="border-fx-right"></div>
              <div className="border-fx-bottom"></div>
              <div className="border-fx-left"></div>
            </div>
            <div className="thumbnail-heading">{folder.design_type}</div>
          </Link> 
        ))}     
      </div>
    </div>
  );
}